import TenantService from "./tenant";

export default TenantService;
